"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTRValidationUtils = void 0;
var Product_1 = require("../../tasks/coverpath/dependencies/Product");
var ValidationUtils_1 = require("../ValidationUtils");
var WholeLifeValidationUtils_1 = require("./WholeLifeValidationUtils");
var RTRValidationUtils = /** @class */ (function () {
    function RTRValidationUtils() {
    }
    RTRValidationUtils.isValidRtrAge = function (productCode, policyFaceAmount, rtrAmount, insuredDateOfBirth) {
        var dob = new Date(insuredDateOfBirth);
        var vRes = {
            isValid: true,
            message: ''
        };
        var rtrConstants = Product_1.RiderConstants.rtr;
        var faceAndRtrAmountSum = policyFaceAmount + rtrAmount;
        var productSpec = rtrConstants.ageLimits[productCode] || rtrConstants.ageLimits['default'];
        // to find the right slab we first need to make sure they are ordered and find the first where the faceAmount
        // is below the slab's upper threshold spec: faceUpTo
        var slab = productSpec.faceAmountSlabs
            .sort(function (s1, s2) { return s1.faceUpTo - s2.faceUpTo; })
            .find(function (s) { return faceAndRtrAmountSum <= s.faceUpTo; });
        if (!slab) {
            // faceAmount out of specs: means the faceAmount was out of any of the slabs defined.
            vRes.isValid = false;
            vRes.message = "Renewable term face amount must be between ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(rtrConstants.minFace), " and ").concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Math.min(20 * policyFaceAmount, rtrConstants.maxFace - policyFaceAmount)));
        }
        else {
            // slab found; check for age limits
            // minimum age is inclusive
            if (ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, slab.minAge)) {
                vRes.isValid = false;
                vRes.message = "RTR not available under age ".concat(slab.minAge);
            }
            else if (ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, slab.maxAge)) {
                // maximum age is exclusive
                vRes.isValid = false;
                vRes.message = "RTR not available above age ".concat(slab.maxAge);
            }
        }
        return vRes;
    };
    // This function is used by the quotes page, amendments, and admin (when generating a revised basic illustration)
    // It takes the scheduled alir amount into consideration when validating
    RTRValidationUtils.validateRtrRider = function (dob, faceAmount, rtrAmount, product, isUsCitizen, scheduledAlirAmount, insuranceAge, maxFaceAmount) {
        maxFaceAmount =
            maxFaceAmount || (isUsCitizen ? Product_1.RiderConstants.rtr.maxFace : Product_1.RiderConstants.rtr.maxFaceForNoncitizens);
        var required = false, belowMinAge = false, aboveMaxAge = false, maxAge = 0, min, max;
        var faceAndRtrAmountSum = faceAmount + rtrAmount;
        var alirAmountTotal = scheduledAlirAmount
            ? WholeLifeValidationUtils_1.WholeLifeValidationUtils.getScheduledALIRTotal(scheduledAlirAmount, faceAndRtrAmountSum, insuranceAge)
            : 0;
        var diffMaxVsCurrentFace = maxFaceAmount - faceAmount - alirAmountTotal;
        var ageValidationResult = this.isValidRtrAge(product, faceAmount, rtrAmount, dob);
        if (!ageValidationResult.isValid && ageValidationResult.message && ageValidationResult.message.indexOf('under') > -1) {
            belowMinAge = true;
        }
        else if (!ageValidationResult.isValid && ageValidationResult.message && ageValidationResult.message.indexOf('above age') > -1) {
            aboveMaxAge = true;
            maxAge = parseFloat(ageValidationResult.message.split('above age ')[1]);
        }
        else if (!faceAmount) {
            required = true;
        }
        else if (rtrAmount < Product_1.RiderConstants.rtr.minFace) {
            min = { min: Product_1.RiderConstants.rtr.minFace };
        }
        else if (rtrAmount > Math.min(20 * faceAmount, diffMaxVsCurrentFace)) {
            max = { max: Math.min(20 * faceAmount, diffMaxVsCurrentFace < 0 ? 0 : diffMaxVsCurrentFace) };
        }
        if (required || min || max || belowMinAge || aboveMaxAge) {
            return {
                rtr: {
                    required: required,
                    min: min,
                    max: max,
                    belowMinAge: belowMinAge,
                    aboveMaxAge: {
                        maxAge: maxAge
                    },
                    combinedMax: max && max.max < Product_1.RiderConstants.rtr.minFace ? maxFaceAmount : null
                }
            };
        }
        return null;
    };
    return RTRValidationUtils;
}());
exports.RTRValidationUtils = RTRValidationUtils;
